import { useEffect } from 'react';
import { protectImageElement, protectAllImagesInContainer } from '../utils/imageProtection';

/**
 * Phase 3: Global image protection (FR 7, FR 8).
 * Protects all img in the document and watches for dynamically added images (e.g. CMS content).
 */
export default function ImageProtection() {
  useEffect(() => {
    protectAllImagesInContainer(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.nodeName === 'IMG') protectImageElement(node);
          if (node.querySelectorAll) node.querySelectorAll('img').forEach(protectImageElement);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
